import React, { useState, useRef } from 'react';
import { bool, func, shape, string, number } from 'prop-types';
import Snackbar from '@andes/snackbar';
import { Button } from '@andes/button';
import { TextField } from '@andes/textfield';
import { Form } from '@andes/form';
import noop from 'lodash/noop';
import { trackEvent } from '../../lib/tracking';
import { validateSnackbarColor } from '../../utils/validators';

const DEFAULT_DELAY_TIME = 3000;

const namespace = 'ui-pdp-budget-demand';

const BudgetDemand = ({
  title = null,
  form = null,
  track = null,
  disabled = false,
  messages = null,
  onCreateBudgetDemand = noop,
}) => {
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  const [isFocus, setIsFocus] = useState(false);

  const onInputChange = e => {
    setValue(e.target.value);
  };

  const onInputFocus = () => {
    trackEvent(form.focus_track);
  };

  const handleOnSubmit = e => {
    e.preventDefault();
    if (value.trim() !== '') {
      onCreateBudgetDemand({
        itemId: form.confirm.item_id,
        text: value,
        track,
      });
      setValue('');
    } else {
      inputRef.current?.querySelector('.andes-form-control__field')?.focus();
      setIsFocus(true);
    }
  };

  return (
    <div className={namespace}>
      {title && <h2 className={`${namespace}__title`}>{title.text}</h2>}
      {form && (
        <Form className={`${namespace}__form`} action={form.confirm.target} method="POST" onSubmit={handleOnSubmit}>
          {form.confirm && <input type="hidden" name="itemId" value={form.confirm.item_id} />}
          <div className={`${namespace}__content`}>
            <TextField
              name="budget-demand"
              data-testid="budget-demand-input"
              className={`${namespace}__input`}
              placeholder={form.placeholder.text}
              ref={innerRef => {
                inputRef.current = innerRef;
              }}
              autoComplete="off"
              value={value}
              onChange={onInputChange}
              onFocus={onInputFocus}
              messageFixed
              maxLength={2000}
              multiline
              focus={isFocus}
              onBlur={() => {
                setIsFocus(false);
              }}
            />
          </div>
          {form.confirm && (
            <Button
              data-testid="budget-demand-button"
              className={`${namespace}__button`}
              hierarchy="loud"
              type="submit"
              disabled={disabled}
            >
              {form.confirm.label.text}
            </Button>
          )}
        </Form>
      )}
      {messages && messages.text && (
        <Snackbar
          delay={DEFAULT_DELAY_TIME}
          message={messages.text}
          color={validateSnackbarColor(messages.type)}
          show
        />
      )}
    </div>
  );
};

BudgetDemand.propTypes = {
  title: shape({
    text: string.isRequired,
  }),
  form: shape({
    confirm: shape({
      target: string.isRequired,
      label: shape({}),
      item_id: string,
    }),
    placeholder: shape({
      text: string,
    }),
    max_length: number,
    track: shape({}),
  }),
  disabled: bool,
  messages: shape({
    text: string,
    type: string,
  }),
  track: shape({}),
  onCreateBudgetDemand: func,
};

export default BudgetDemand;
